import api from '@utils/api';

export function submitRating(payload) {
  return api.post('/ratings', payload);
}

export function getUserRatings(userId) {
  return api.get(`/users/${userId}/ratings`);
}

export function checkCanRate(activityId) {
  return api.get(`/activities/${activityId}/can-rate`);
}

